<template>
  <NewQuotationAgro v-if="currentQuotation != null" />
</template>
<script>
import NewQuotationAgro from "./NewQuotationAgro";
import { mapActions } from "vuex";
import { LoadingRequest } from "@/mixins/LoadingMixin";
export default {
  data: () => ({
    currentQuotation: null
  }),
  components: {
    NewQuotationAgro
  },
  mixins: [LoadingRequest],
  created() {
    this.fetchQuotation();
  },
  methods: {
    ...mapActions("quotation", ["requestCurrentQuotationAgro"]),
    fetchQuotation() {
      this.withLoading(this.setQuotation());
    },
    async setQuotation() {
      this.currentQuotation = await this.requestCurrentQuotationAgro(
        this.$route.params.id
      );
    }
  }
};
</script>
